<template>
  <div>
    <v-wait for="Lens List"
      ><template slot="waiting">
        <div class="text-center mb-3">
          <b-spinner></b-spinner>
        </div>
      </template>
      <div class="table-title-wrapper">
        <h6 class="text-uppercase rd-title" v-if="showTitle">Available Lenses</h6>
        <a @click="resetLens" v-if="selectable && !errorMessage">Reset</a>
      </div>
      <ul class="list-unstyled rd-list lens-list">
        <LensListItem
          v-for="lens in availableLenses.filter(lens => !lens.is_upgrade)"
          :key="lens.id"
          :lens="lens"
          :selectable="selectable"
          :collapsible="collapsible"
          v-model="$store.state.selectedLens"
          @edit="onEdit"
          @deleted="onDeleted"
        ></LensListItem>
      </ul>
      <ErrorMessage v-if="availableLenses.length === 0 && grindLenses.length === 0" type="box">{{ errorMessage || 'No lens available' }}</ErrorMessage>
      
      <!-- Grind Options Section -->
      <div v-if="grindLenses.length > 0" class="grind-options mt-4">
        <div class="table-title-wrapper">
          <h6 class="text-uppercase rd-title d-flex align-items-center">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2" style="flex-shrink: 0;">
              <path d="M16.5 18.2998C16.1167 18.5165 15.7165 18.6875 15.2998 18.8125C14.8832 18.9375 14.4499 19 14 19C13.7167 19 13.4458 18.9748 13.1875 18.9248C12.9292 18.8748 12.6748 18.8079 12.4248 18.7246L13.4492 16.9482C13.6278 16.9814 13.8118 17 14 17C14.5489 17 15.0613 16.8492 15.5039 16.5918L16.5 18.2998ZM11.1738 15C11.4126 15.6749 11.8851 16.2368 12.4951 16.5918L11.5 18.2998C10.8834 17.9498 10.3668 17.4914 9.9502 16.9248C9.53354 16.3581 9.24961 15.7167 9.09961 15H11.1738ZM9 0C10.8833 0 12.5796 0.525195 14.0879 1.5752C15.596 2.62513 16.683 3.97519 17.3496 5.625C17.4496 5.89167 17.4496 6.15039 17.3496 6.40039C17.2496 6.65014 17.0663 6.82487 16.7998 6.9248C16.5332 7.02475 16.271 7.02475 16.0127 6.9248C15.7544 6.8248 15.5746 6.64167 15.4746 6.375C14.958 5.07523 14.121 4.02116 12.9629 3.21289C11.8046 2.40456 10.4833 2 9 2C7.05 2 5.39544 2.67878 4.03711 4.03711C2.67878 5.39544 2 7.05 2 9C2 10.1999 2.27089 11.2998 2.8125 12.2998C3.35417 13.2998 4.08333 14.1167 5 14.75V13C5 12.7167 5.09544 12.4788 5.28711 12.2871C5.47878 12.0954 5.71667 12 6 12C6.28333 12 6.52122 12.0954 6.71289 12.2871C6.90456 12.4788 7 12.7167 7 13V17C7 17.2833 6.90456 17.5212 6.71289 17.7129C6.52122 17.9046 6.28333 18 6 18H2C1.71667 18 1.47878 17.9046 1.28711 17.7129C1.09544 17.5212 1 17.2833 1 17C1 16.7167 1.09544 16.4788 1.28711 16.2871C1.47878 16.0954 1.71667 16 2 16H3.34961C2.31643 15.1667 1.50034 14.1457 0.900391 12.9375C0.300391 11.7292 0 10.4167 0 9C0 7.75 0.237891 6.57897 0.712891 5.4873C1.18788 4.39577 1.82944 3.44595 2.6377 2.6377C3.44595 1.82944 4.39577 1.18788 5.4873 0.712891C6.57897 0.237891 7.75 0 9 0ZM19 14C19 14.75 18.8498 15.4419 18.5498 16.0752C18.2498 16.7084 17.833 17.258 17.2998 17.7246L16.2754 15.9502C16.7255 15.4255 17 14.7456 17 14H19ZM11.7236 12.0488C11.2734 12.5736 11 13.2544 11 14H9C9 13.25 9.15456 12.5581 9.46289 11.9248C9.77119 11.2916 10.1837 10.742 10.7002 10.2754L11.7236 12.0488ZM16.5 9.7002C17.1166 10.0502 17.6332 10.5086 18.0498 11.0752C18.4665 11.6419 18.7504 12.2833 18.9004 13H16.8262C16.5872 12.3247 16.1145 11.7622 15.5039 11.4072L16.5 9.7002ZM14 9C14.2833 9 14.5542 9.0252 14.8125 9.0752C15.0708 9.12519 15.3252 9.19206 15.5752 9.27539L14.5498 11.0508C14.3715 11.0178 14.1878 11 14 11C13.451 11 12.9378 11.1497 12.4951 11.4072L11.5 9.7002C11.8833 9.48353 12.2835 9.3125 12.7002 9.1875C13.1168 9.06254 13.5501 9 14 9Z" fill="#1F1F1F"/>
            </svg>
            Upgrade to single vision grind
          </h6>
        </div>
        
        <ul class="list-unstyled rd-list lens-list">
          <LensListItem
            v-for="lens in grindLenses"
            :key="lens.id"
            :lens="lens"
            :selectable="selectable"
            :collapsible="collapsible"
            v-model="$store.state.selectedLens"
            @edit="onEdit"
            @deleted="onDeleted"
            @upgrade-reason-input="onUpgradeReasonInput(lens, $event)"
          ></LensListItem>
        </ul>
      </div>
    </v-wait>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ErrorMessage from '@/components/ErrorMessage.vue';
import apiLenses from '../api/lenses';
import LensListItem from './LensListItem.vue';

export default {
  name: 'LensList',
  components: {
    LensListItem,
    ErrorMessage,
  },
  props: {
    customer: Object,
    prescription: Object,
    showTitle: Boolean,
    selectable: Boolean,
    collapsible: Boolean,
  },
  data() {
    return {
      availableLenses: [],
      errorMessage: null,
    };
  },
  computed: {
    grindLenses() {
      return this.availableLenses.filter(lens => lens.is_upgrade);
    },
    ...mapState({
      job: state => state.jobsModule.selectedJobData,
      selectedLens: state => state.jobsModule.selectedLens,
      selectedPrescriptionType: state => state.jobsModule.selectedPrescriptionType,
      selectedPrescription: state => state.jobsModule.selectedPrescription,
      selectedPd: state => state.jobsModule.selectedPd,
      selectedFrameData: state => state.jobsModule.selectedFrameData,
    }),
    productLensesType() {
      return this._.get(this.job, 'item.region_product.product.type.lenses_type');
    },
    productTypeKey() {
      return this._.get(this.job, 'item.region_product.product.type.key');
    },
    isSingleVisionProduct() {
      const lensesType = this.productLensesType || '';
      const typeKey = this.productTypeKey || '';
      return lensesType.includes('single-vision') || typeKey.includes('single-vision');
    },
    prescriptionTypeForQuery() {
      if (this.isSingleVisionProduct) {
        return this.selectedPrescriptionType;
      }
      return this.productLensesType;
    },
    lensQueryParams() {
      return {
        region_product_id: this.job.item.region_product_id,
        prescription_id: this.selectedPrescription.id,
        prescription_type: this.prescriptionTypeForQuery,
        pd_id: this.selectedPd.detail.id,
        frame_size: this.selectedFrameData.frameSize,
        frame_shape: this.mapFrameShape(this.selectedFrameData.shape),
      };
    },
  },
  watch: {
    errorMessage: {
      immediate: true,
      handler(newVal) {
        this.$emit('error-state', !!newVal);
      }
    },
    availableLenses: {
      immediate: true,
      handler(newVal) {
        this.$emit('update:availableLenses', newVal);
      }
    },
    selectedPd: {
      handler: 'loadLensData'
    },
    selectedPrescription: {
      handler: 'loadLensData'
    },
    selectedPrescriptionType: {
      handler: 'loadLensData'
    },
    selectedFrameData: {
      handler: 'loadLensData',
      deep: true
    }
  },
  methods: {
    loadLensData() {
      this.errorMessage = null;
      this.availableLenses = [];

      if (
        !this.selectedPd?.detail?.id ||
        !this.selectedPrescription?.id ||
        !this.job?.item?.region_product_id ||
        !this.prescriptionTypeForQuery
      ) {
        return;
      }

      // DP-5683: a PD that does not meet the lens type (e.g. multifocal without monocular PD) gets no
      // lenses to pick, the reason is shown instead, as the order item and the PD step show it
      if (this.selectedPd.pdPresenter?.error) {
        this.errorMessage = this.selectedPd.pdPresenter.message;
        return;
      }

      // DP-5685: intermediate lenses need an Int Add, same rule as the Purpose option on the Prescription step
      const rx = this.selectedPrescription;
      if (this.prescriptionTypeForQuery === 'intermediate' && !(rx.add_int || (rx.right_int_add && rx.left_int_add))) {
        this.errorMessage = 'Intermediate glasses need a prescription with an Int Add';
        return;
      }

      this.$wait.start('Lens List');
      apiLenses
        .getLensAddonCombination(this.lensQueryParams)
        .then(response => {
          this.$wait.end('Lens List');
          // The PD was re-checked for this lens type while the lenses loaded (DP-5720)
          if (this.selectedPd?.pdPresenter?.error) return;
          if (this._.get(response.data, 'invalid_error_msg')) {
            this.errorMessage = this._.get(response.data, 'invalid_error_msg');
          } else {
            const datas = Object.assign([], response.data);
            this.processLensData(datas);
          }
        })
        .catch(() => {
          this.$wait.end('Lens List');
        });
    },
    mapFrameShape(shape) {
      if (!shape) return 'classic'; // Default value

      const shapeMapping = {
        original: 'classic',
        capote: 'round',
        classic: 'classic',
        round: 'round',
        'non-dresden': 'non-dresden',
      };

      return shapeMapping[shape.toLowerCase()] || 'classic';
    },
    resetLens() {
      this.$store.commit('jobsModule/SET_SELECTED_LENS', null);
      this.loadLensData();
    },

    processLensData(datas) {
      const shamirLenses = datas.filter(lens => lens.lenses.supplier.name.includes('Shamir'));
      const shamirLongLenses = shamirLenses.filter(lens =>
        lens.lenses.name.toLowerCase().includes('long'),
      );
      const shamirMediumOtherLenses = shamirLenses.filter(
        lens =>
          !lens.lenses.name.toLowerCase().includes('long') &&
          lens.lenses.name.toLowerCase().includes('medium'),
      );
      const shamirOtherLenses = shamirLenses.filter(
        lens =>
          !lens.lenses.name.toLowerCase().includes('long') &&
          !lens.lenses.name.toLowerCase().includes('medium'),
      );
      const hoyaLenses = datas.filter(lens => lens.lenses.supplier.name.includes('Hoya'));
      const hoyaLongLenses = hoyaLenses.filter(lens =>
        lens.lenses.name.toLowerCase().includes('long'),
      );
      const hoyaMediumOtherLenses = hoyaLenses.filter(
        lens =>
          !lens.lenses.name.toLowerCase().includes('long') &&
          lens.lenses.name.toLowerCase().includes('medium'),
      );
      const hoyaOtherLenses = hoyaLenses.filter(
        lens =>
          !lens.lenses.name.toLowerCase().includes('long') &&
          !lens.lenses.name.toLowerCase().includes('medium'),
      );
      const otherLenses = datas.filter(
        lens =>
          !lens.lenses.supplier.name.includes('Shamir') &&
          !lens.lenses.supplier.name.includes('Hoya'),
      );

      this.availableLenses = hoyaLongLenses
        .concat(hoyaOtherLenses)
        .concat(hoyaMediumOtherLenses)
        .concat(shamirMediumOtherLenses)
        .concat(shamirOtherLenses)
        .concat(shamirLongLenses)
        .concat(otherLenses)
        .filter(lens => !lens.invalid_error_msg)
        .filter(lens => !lens.lenses.supplier.name.includes('Zeiss'));

      this.handleLensFiltering();
    },

    handleLensFiltering() {
      let checkZeiss = false;
      let checkHoya = false;

      if (this.availableLenses.length >= 2) {
        if (
          this.availableLenses.filter(lens => lens.lenses.supplier.name.includes('Zeiss'))
            .length > 0
        ) {
          checkZeiss = true;
        }

        if (
          this.availableLenses.filter(lens => lens.lenses.supplier.name.includes('Hoya'))
            .length > 0
        ) {
          checkHoya = true;
        }

        if (checkZeiss && checkHoya) {
          this.availableLenses = this.availableLenses.filter(
            lens => !lens.lenses.supplier.name.includes('Zeiss'),
          );
        }
      } else if (this.availableLenses.length === 0) {
        this.errorMessage = 'No lens available';
      }

      const jobLensId = this._.get(this.job, 'lenses.id');
      const jobLensAddonId = this._.get(this.job, 'item.additional_info.data.lens_addon_combination.id');

      let existingLens = null;

      if (jobLensAddonId) {
        existingLens = this._.find(this.availableLenses, { id: jobLensAddonId });
      }
      if (!existingLens && jobLensId) {
        existingLens = this._.find(this.availableLenses, { id: jobLensId })
          || this._.find(this.availableLenses, { lens_id: jobLensId });
      }

      const regularLenses = this.availableLenses.filter(lens => !lens.is_upgrade);
      const autoSelectLens = !existingLens && !this.job.lenses && regularLenses.length === 1
        ? regularLenses[0]
        : null;

      const selectedLens = existingLens || this.job.lenses || autoSelectLens;

      if (selectedLens) {
        const upgradeReason = this._.get(this.job, 'item.upgrade_reason') ||
          this._.get(this.job, 'item.additional_info.data.product_upgrade_reason');
        if (upgradeReason) {
          selectedLens.upgrade_reason = upgradeReason;
        }
        const savedMod = this._.get(this.job, 'item.additional_info.data.selected_lens_mod');
        if (savedMod) {
          selectedLens.selected_lens_mod = savedMod;
        }
        const savedCorridorMod = this._.get(this.job, 'item.additional_info.data.selected_lens_mod_corridor');
        if (savedCorridorMod) {
          selectedLens.selected_lens_mod_corridor = savedCorridorMod;
        }
        this.$store.commit('jobsModule/SET_SELECTED_LENS', selectedLens);
      }

      this.$store.commit('jobsModule/SET_SELECTED_LENSCOATING', this.availableLenses);
    },
    onEdit(e) {
      this.$emit('edit', {
        customer: {
          id: this.customer.id,
          full_name: this.customer.full_name,
        },
        prescription: e.prescription,
      });
    },
    onClick() {
      this.$emit('new', {
        customer: {
          id: this.customer.id,
          full_name: this.customer.full_name,
        },
      });
    },
    onDeleted(e) {
      this.$emit('deleted', e);
    },
    onUpgradeReasonInput(lens, reason) {
      // Update the upgrade_reason on the lens object
      lens.upgrade_reason = reason;
      // If this lens is currently selected, update the store as well
      if (this.selectedLens && (this.selectedLens.id === lens.id || this.selectedLens.lens_id === lens.lens_id)) {
        const updatedLens = { ...this.selectedLens, upgrade_reason: reason };
        this.$store.commit('jobsModule/SET_SELECTED_LENS', updatedLens);
        // Optionally, emit to parent to keep in sync
        this.$emit('upgrade-reason-input', { lens: updatedLens, reason });
      }
    },
  },
  mounted() {
    this.loadLensData();
  }
};
</script>
